import Vue from 'vue';

Vue.component('hidden-top-navigation', {
    mounted() {
        this.handleToggleVisibilityOnScroll();
    },

    methods: {
        handleToggleVisibilityOnScroll() {
            let lastScrollTop = 0;
            const header = document.querySelector('.hidden-top-navigation');

            if (!header) return;

            window.addEventListener('scroll', () => {
                let scrollTop =
                    window.scrollY || document.documentElement.scrollTop;

                if (scrollTop < 100) {
                    lastScrollTop = 0;
                    this.hideHeader(header);
                    return;
                }

                if (scrollTop < lastScrollTop) {
                    this.showHeader(header);
                } else {
                    this.hideHeader(header);
                }

                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
            });
        },

        showHeader(headerElement) {
            headerElement.classList.remove('hidden-top-navigation--hidden');
            headerElement.classList.add('hidden-top-navigation--visible');
        },

        hideHeader(headerElement) {
            headerElement.classList.remove('hidden-top-navigation--visible');
            headerElement.classList.add('hidden-top-navigation--hidden');
        },
    },
});
